import { useState } from "react";
import { Alert, Button, Chip, Paper, Stack, Typography } from "@mui/material";
import { availableOptions, chooseOption } from "../Utility/storyFormat";

export default function StoryPreview({ rows }) {
  const [state, setState] = useState({
    node: 1,
    traits: [],
    text: "Your story begins with a choice.",
  });
  const options = availableOptions(rows, state.node, state.traits);
  return (
    <Paper variant="outlined" sx={{ p: { xs: 2, sm: 4 } }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Typography variant="h5">Play your draft</Typography>
        <Button
          onClick={() =>
            setState({
              node: 1,
              traits: [],
              text: "Your story begins with a choice.",
            })
          }
        >
          Restart
        </Button>
      </Stack>
      <Typography sx={{ whiteSpace: "pre-wrap", mb: 3 }}>
        {state.text}
      </Typography>
      <Stack spacing={1}>
        {options.map((option, index) => (
          <Button
            key={index}
            variant="outlined"
            onClick={() => setState(chooseOption(option, state.traits))}
          >
            {option.optionText || "Untitled choice"}
          </Button>
        ))}
      </Stack>
      {!options.length && (
        <Alert severity="info">
          {state.node === 0
            ? "The end."
            : "No available choices here. Check your branches and tag rules."}
        </Alert>
      )}
      <Stack direction="row" gap={1} flexWrap="wrap" mt={3}>
        {state.traits.map((tag) => (
          <Chip key={tag} label={tag} size="small" />
        ))}
      </Stack>
    </Paper>
  );
}
